export type ProductMatchField = 'ean' | 'sku';

export interface ShopifyProductMatchMapping {
  sourceField: string;
  targetField: string;
}

export interface AmazonProductMatchMapping {
  sourceField: string;
  targetField: string;
}

export interface AmazonSettings {
  import?: {
    productMatchMapping?: AmazonProductMatchMapping;
  };
}

export type ConnectionSettings = ProductFlowSettings | ShopifySettings | EmptyConnectionSettings;

export interface EmptyConnectionSettings {
}

export interface ShopifySettings {
    import?: {
        /** @deprecated Use productMatchMapping instead. */
        productMatchField?: ProductMatchField | 'shopifyProductId';
        productMatchMapping?: ShopifyProductMatchMapping;
    };
}

export interface ProductFlowSettings {
    import?: {
        allowedMarketplaces?: string[];
        allowedCountries?: string[];
        productMatchField?: ProductMatchField;
        sourceMatchField?: ProductMatchField;
    };
}

export const DEFAULT_SHOPIFY_PRODUCT_MATCH_MAPPING: ShopifyProductMatchMapping = {
  sourceField: 'variants.barcode',
  targetField: 'ean',
};

export const DEFAULT_AMAZON_PRODUCT_MATCH_MAPPING: AmazonProductMatchMapping = {
  sourceField: 'sku',
  targetField: 'sku',
};

export function resolveAmazonProductMatchMapping(
  settings?: AmazonSettings['import'],
): AmazonProductMatchMapping {
  const mapping = settings?.productMatchMapping;
  if (mapping?.sourceField && mapping?.targetField) return mapping;
  return DEFAULT_AMAZON_PRODUCT_MATCH_MAPPING;
}

export function resolveShopifyProductMatchMapping(
  settings?: ShopifySettings['import'],
): ShopifyProductMatchMapping {
  const mapping = settings?.productMatchMapping;
  if (mapping?.sourceField && mapping?.targetField) {
    return mapping;
  }

  switch (settings?.productMatchField) {
    case 'sku':
      return { sourceField: 'variants.sku', targetField: 'sku' };
    case 'shopifyProductId':
      return { sourceField: 'id', targetField: 'customFields.shopifyProductId' };
    case 'ean':
    default:
      return DEFAULT_SHOPIFY_PRODUCT_MATCH_MAPPING;
  }
}
